import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateTrackedKeywordRequest, TrackedKeyword } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateTrackedKeyword() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateTrackedKeywordRequest) =>
      apiPost<TrackedKeyword>('/v1/tracked-keywords', input, {
        headers: { 'idempotency-key': crypto.randomUUID() },
      }),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: ['tracked-keywords', vars.project_id] });
      void qc.invalidateQueries({ queryKey: ['rank-summary', vars.project_id] });
      void qc.invalidateQueries({ queryKey: ['impact-cards', vars.project_id] });
    },
  });
}
